/**
 * Renders text with **bold** markdown syntax as <strong> elements.
 * Only supports bold — not a full markdown parser.
 */
const MarkdownBoldText = ({ text }: { text: string }) => {
  const parts = text.split(/\*\*(.*?)\*\*/g);

  return (
    <span>
      {parts.map((part, i) =>
        i % 2 === 1 ? <strong key={i}>{part}</strong> : part,
      )}
    </span>
  );
};

export default MarkdownBoldText;
